import React, { useEffect, useState } from "react";
import GetHeroIcon from "../../utils/getHeroIcon";

export interface Groupbutton
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  iconposition?: "leading" | "trailing";
  iconname?: string;
  testid?: string;
  disable?: boolean;
  value?: any;
}
interface ButtonGroupProps {
  buttons: Groupbutton[];
  defaultValue?: number;
  setterFunction?: (value: any) => void;
  selectedButton?: (val: any) => void;
  iconOnly?: boolean;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  defaultValue,
  selectedButton,
  iconOnly,
  setterFunction
}) => {
  const [activeButton, setActiveButton] = useState<number | undefined>(
    defaultValue
  );

  useEffect(() => {
    setActiveButton(defaultValue);
  }, [defaultValue]);

  const handleClick = (val: number) => {
    setActiveButton(val);
    selectedButton?.(val);
  };

  return (
    <span className="isolate inline-flex rounded-md">
      {buttons.map((button, index) => {
        let classNames =
          "relative inline-flex items-center shadow-sm px-3 py-2 text-sm font-semibold focus:z-10 ";

        if (index === 0) {
          classNames += " rounded-l-md ";
        } else if (index === buttons.length - 1) {
          classNames += " rounded-r-md ";
        }
        if (activeButton === index) {
          classNames += " bg-primary text-white ";
        } else {
          classNames +=
            " bg-bkg text-secondary/80 ring-1  ring-secondary/20   hover:bg-secondary/5 ring-inset ";
        }
        if (button.disable === true) {
          classNames +=
            " disabled:!pointer-events-auto disabled:!cursor-not-allowed  ";
        }

        return (
          <button
            key={index}
            type="button"
            disabled={button.disable}
            className={classNames}
            onClick={(e) => {
              setActiveButton(index);
              setterFunction && setterFunction(e);
              selectedButton && selectedButton(index);
            }}
            {...button}
            data-testid={
              button.testid
                ? button.testid
                : `btngroup${button?.label?.replace(/\s/g, "")}`
            }
          >
            {iconOnly && button.iconname ? (
              <GetHeroIcon
                name={button.iconname}
                className="-mr-0.5 w-5 h-5"
                aria-hidden="true"
              />
            ) : button.iconname && button.iconposition !== "trailing" ? (
              <>
                <GetHeroIcon
                  name={button.iconname}
                  className="mr-1 w-5 h-5"
                  aria-hidden="true"
                />

                {button.label}
              </>
            ) : button.iconname && button.iconposition === "trailing" ? (
              <>
                {button.label}
                <GetHeroIcon
                  name={button.iconname}
                  className="ml-1 w-5 h-5"
                  aria-hidden="true"
                />
              </>
            ) : (
              <>{button.label}</>
            )}
          </button>
        );
      })}
    </span>
  );
};

export default ButtonGroup;
